import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';

export default {
	name: 'line-haul-status-code',
	components: {
		BasicSelect,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			bagNoErrorFlg:false,
			bagNoErrorMsg:'',
			shippingIdErrorFlg:false,
			shippingIdErrorMsg:'',
			multiPartGrpIdErrorFlg:false,
			multiPartGrpIdErrorMsg:'',
			errorCode:0,
			multiPartGrpId:'',
			shippingId:'',
			bagno:'',
			confirmUnlikForBag:false,
			confirmUnlikForShippingId:false
		}
	},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.hubid = userdetail[0].HubId[0];
		this.createdby = userdetail[0].email
	},
	methods: {

		unLinkBagNo() {

			this.input = ({
				"BagNo": this.bagno.trim(),
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'removeMultiShipmentGroupIdForBag',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage)
						this.resetFormForBag();
					} else {
						this.$alertify.error(result.data.ReturnMessage)
						this.confirmUnlikForBag=false,
						this.confirmUnlikForShippingId=false
					}
				}, error => {
					console.error(error)
				})
		},
		unLinkShippingId() {

			this.input = ({
				"MultiShipmentGroupId": this.multiPartGrpId.trim(),
				"ShippingId": this.shippingId.trim()
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'dlinkMultiShipmentGroupId',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage)
						this.resetForm();
					} else {
						this.$alertify.error(result.data.ReturnMessage)
						this.confirmUnlikForBag=false,
						this.confirmUnlikForShippingId=false
					}
				}, error => {
					console.error(error)
				})
		},
		cofirmBagField() {
			this.bagNoErrorFlg=false,
			this.bagNoErrorMsg=''
			if(!this.bagno)
			{
				this.bagNoErrorFlg=true,
				this.bagNoErrorMsg="Enter bag no"
				return false;
			}
			this.confirmUnlikForBag = true;
		},
		closeBagConfirmation() {
			this.confirmUnlikForBag = false;
		},
		cofirmShippingIdField() {
			this.errorCode=0;
			this.multiPartGrpIdErrorFlg=false,
			this.multiPartGrpIdErrorMsg=''
			this.shippingIdErrorFlg=false,
			this.shippingIdErrorMsg=''
			if(!this.multiPartGrpId)
			{
				this.multiPartGrpIdErrorFlg=true,
				this.multiPartGrpIdErrorMsg="Enter multi Part group id"
				this.errorCode=1;
			}
			if(!this.shippingId)
			{
				this.shippingIdErrorFlg=true,
				this.shippingIdErrorMsg="Enter multi Part group id"
				this.errorCode=1;
			}
			if(this.errorCode ==1)
			{
				return false;
			}
			this.confirmUnlikForShippingId = true;
		},
		closeShippingIdConfirmation() {
			this.confirmUnlikForShippingId = false;
		},
		resetFormForBag(){
			this.bagNoErrorFlg=false,
			this.bagNoErrorMsg='',
			this.bagno='',
			this.confirmUnlikForBag=false
		},
		resetForm() {
			this.shippingIdErrorFlg=false,
			this.shippingIdErrorMsg='',
			this.multiPartGrpIdErrorFlg=false,
			this.multiPartGrpIdErrorMsg='',
			this.errorCode=0,
			this.multiPartGrpId='',
			this.shippingId='',
			this.confirmUnlikForShippingId=false

			this.$validator.reset()
		},
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				} else {
					this.updateLHStatusCode();
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/unlinkMultiPartGrpId/unlinkMultiPartGrpId.js